import { type OriginQuery, teamsClient } from '@atlaskit/teams-client';
import { type TeamMembership, type User } from '@atlaskit/teams-client/types';

import type { StoreApi } from '../../types';
import { getRequestingToJoinUsers } from '../requesting-to-join-users';

import { joinTeamState } from './utils';

export const becomeTeamMember =
	(teamId: string, member: Required<TeamMembership>) =>
	({ getState, setState }: StoreApi) => {
		const state = getState();

		if (state.teamProfile.teamId !== teamId) {
			return;
		}

		const nextState = joinTeamState(state, member);
		setState(nextState);
	};

export const joinTeam =
	(teamId: string, originQuery: OriginQuery, user: User) =>
	async ({ dispatch }: StoreApi): Promise<TeamMembership> => {
		const response = await teamsClient.selfJoinTeam(teamId, originQuery);

		const newMembership = {
			...response,
			user,
		};

		dispatch(becomeTeamMember(teamId, newMembership));

		return response;
	};

export const acceptTeamInvitation =
	(teamId: string, currentUserId: string) =>
	async ({ dispatch, getState }: StoreApi) => {
		const response = await teamsClient.acceptTeamInvitation(teamId);

		const existingUser = getState().teamMembers.members.find(
			(member) => member.membershipId.memberId === currentUserId,
		);

		// This membership MUST exist for the user to be able to call this function,
		// and `user` will be defined as this membership comes from the directory.
		if (!existingUser || !existingUser.user) {
			return;
		}
		const newMembership: Required<TeamMembership> = {
			...response,
			user: existingUser.user,
		};

		dispatch(becomeTeamMember(teamId, newMembership));

		// Don't await this, let them load afterwards
		void dispatch(getRequestingToJoinUsers(teamId));
	};
